import { React, useState, useEffect, useCallback } from "react";
import { useLazyQuery } from "@apollo/client";
import { query } from "./queries/buscadorGeneral";
import Card from "./Card";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";

//libreria con la que se implemento el slider
//https://react-slick.neostack.com/docs/example/resizable
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carrusel.css";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className="slick-arrow"
      style={{
        ...style,
        display: "block",
        position: "absolute",
        zIndex: "999",
        top: "30%",
        cursor: "pointer",
        right: "0",
      }}
      onClick={onClick}
    >
      <i class="bi bi-chevron-right" style={{ fontSize: "35px" }}></i>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return <></>;
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function App() {
  var today = new Date();
  var year = today.getFullYear();

  const [getNumeralia, { loading, error, data }] = useLazyQuery(query, {
    variables: { annio: year },
  });
  const [currentyear, setCurrentyear] = useState(year);

  const obtenerNumeralia = useCallback(() => {
    getNumeralia({
      options: { fetchPolicy: "no-cache" },
      variables: { size: 1000 },
    });
    // setNumeralia(data.numeralia);
  }, [getNumeralia]);

  useEffect(() => {
    //Se recuperan los datos
    obtenerNumeralia();
  }, []);

  function setDataNumeralia(newCurrentYear) {
    setCurrentyear(newCurrentYear);
    getNumeralia({ variables: { annio: newCurrentYear } });
  }

  return (
    <>
      {data && data.numeralia != null && (
        <>
          <div className="container">
            <div className="row text-center">
              <h2 className="ecosur-title-1-bold margin-general">
                <b>Ecosur en números</b>
              </h2>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <ul
                className="nav nav-pills justify-content-center mb-3"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    onClick={() => setDataNumeralia(year)}
                    className={
                      currentyear == year ? "nav-link active" : "nav-link"
                    }
                    data-bs-toggle="pill"
                  >
                    {year}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    onClick={() => setDataNumeralia(year - 1)}
                    className={
                      currentyear == year - 1 ? "nav-link active" : "nav-link"
                    }
                    data-bs-toggle="pill"
                  >
                    {year - 1}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    onClick={() => setDataNumeralia(year - 2)}
                    className={
                      currentyear == year - 2 ? "nav-link active" : "nav-link"
                    }
                    data-bs-toggle="pill"
                  >
                    {year - 2}
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-year"
                  role="tabpanel"
                >
                  <Slider {...settings} id="sliderNumeralia">
                    {data.numeralia.academicos > 0 && (
                      <Card
                        title="Personal académico"
                        number={String(data.numeralia.academicos)}
                        logo="bi bi-people"
                        url={
                          "/ecoconsulta/academicos?filtros=%255B%28%27value%21%27estatus%27%7Eelements%21%255B%27Activo%27%255D%29%255D%2501"
                        }
                      />
                    )}
                    {data.numeralia.publicaciones > 0 && (
                      <Card
                        title="Publicaciones científicas"
                        number={String(data.numeralia.publicaciones)}
                        logo="bi bi-file-bar-graph"
                        url={
                          "/ecoconsulta/publicaciones?filtros=%255B('value!'annio'~elements!%255B" +
                          year +
                          "%255D)%255D%2501"
                        }
                      />
                    )}
                    {data.numeralia.actividades > 0 && (
                      <Card
                        title="Publicaciones de divulgación"
                        number={String(data.numeralia.actividades)}
                        logo="bi bi-megaphone"
                        url={
                          "/ecoconsulta/publicaciones?filtros=%255B-annio*" +
                          year +
                          "%255D%29%252C-categoria*%27Vinculaci%25C3%25B3n%27%255D%29%255D*%27%7Eelements%21%255B-%28%27value%21%27%2501-*"
                        }
                      />
                    )}
                    {data.numeralia.proyectos > 0 && (
                      <Card
                        title="Proyectos de investigación con financiamiento activos"
                        number={String(data.numeralia.proyectos)}
                        logo="bi bi-graph-up"
                        url={
                          "/ecoconsulta/proyectos?filtros=%255B-annioproyecto*" +
                          year +
                          "%255D%29%252C-estatu*%27Activo%27%255D%29%255D*s%27%7Eelements%21%255B-%28%27value%21%27%2501-*"
                        }
                      />
                    )}
                    {currentyear == year && data.numeralia.estudiantes &&
                      <Card
                        title="Estudiantes del Posgrado activos"
                        number={String(
                          SumarActivosEgresados(data.numeralia.estudiantes)
                        )}
                        logo="bi bi-mortarboard"
                        url={
                          "/ecoconsulta/estudiantes?filtros=%255B('value!'estatus'~elements!%255B'Activo'~Egresado'%255D)%255D%2501"
                        }
                      />
                    }
                    {/*currentyear == year &&
                      data.numeralia.estudiantes[0].doc_count > 0 && (
                        <Card
                          title="Estudiantes del Posgrado activos"
                          number={String(
                            data.numeralia.estudiantes[0].doc_count
                          )}
                          logo="bi bi-mortarboard"
                          url={
                            "/ecoconsulta/estudiantes?filtros=%255B%28%27value%21%27estatus%27%7Eelements%21%255B%27Activo%27%255D%29%255D%2501"
                          }
                        />
                      )*/}
                    {data.numeralia.educontinua > 0 && (
                      <Card
                        title="Educación Continua"
                        number={String(data.numeralia.educontinua)}
                        logo="bi bi-person-workspace"
                        url={
                          "/ecoconsulta/cursos?filtros=%255B%28%27value%21%27annio%27%7Eelements%21%255B" +
                          year +
                          "%255D%29%255D%2501"
                        }
                      />
                    )}
                    {data.numeralia.prensa > 0 && (
                      <Card
                        title="Prensa"
                        number={String(data.numeralia.prensa)}
                        logo="bi bi-newspaper"
                        url={
                          "/ecoconsulta/prensa?filtros=%255B%28%27value%21%27annio%27%7Eelements%21%255B" +
                          year +
                          "%255D%29%255D%2501"
                        }
                      />
                    )}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

function SumarActivosEgresados(estudiantes){
  let resultado = 0;
  estudiantes.forEach(item => {
    resultado += item.doc_count;
  });
  return resultado;
}

export default App;
